module.exports = __webpack_public_path__ + "static/img/home_case_logoWall.feb5fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_case_logoWall.png
// module id = VWkj
// module chunks = 34